module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"number-of-items-to-display":"表示する件数:","display-item":"{totalCount} 件中 {firstItem}～{lastItem} 件を表示"}}')
  delete Component.options._Ctor
}
